export const environment = {
  production: true,
  urlAddress: "https://zephyr-api-dev.tourism-software.solutions",
  apiUrl: "https://zephyr-api-dev.tourism-software.solutions",
};
